var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Redmarrer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 6 C 23.048235 6 22.141037 6.095179 21.275391 6.2265625 A 1.50015 1.50015 0 1 0 21.724609 9.1914062 C 22.492963 9.0747896 23.247765 9 24 9 C 32.3024 9 39 15.6976 39 24 C 39 32.3024 32.3024 39 24 39 C 15.6976 39 9 32.3024 9 24 C 9 20.065743 10.527501 16.519538 13 13.849609 L 13 17.5 A 1.50015 1.50015 0 1 0 16 17.5 L 16 10.5 A 1.50015 1.50015 0 0 0 14.5 9 L 7.5 9 A 1.50015 1.50015 0 1 0 7.5 12 L 10.605469 12 C 7.7471496 15.184124 6 19.390676 6 24 C 6 33.9236 14.0764 42 24 42 C 33.9236 42 42 33.9236 42 24 C 42 14.0764 33.9236 6 24 6 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Redmarrer);
export default __webpack_public_path__ + "static/media/icons8-redémarrer.faac770daa880ba38fc19bd32f88c468.svg";
export { ForwardRef as ReactComponent };